module.exports = __webpack_public_path__ + "img/pic_trial.3452ba37.png";